/** Returns true when the JWT access token exists and is not expired (30s skew). */
export function isAccessTokenValid(accessToken: string | null | undefined): boolean {
  if (!accessToken) return false;

  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1])) as { exp?: number };
    if (!payload.exp) return false;
    return Date.now() < payload.exp * 1000 - 30_000;
  } catch {
    return false;
  }
}
